import { parseISO, format, differenceInCalendarDays } from 'date-fns';

export function asCurrency(price) {
  const numericPrice = Number(price)
  const asCurrency = numericPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
  if (numericPrice < 0)
    return "(" + asCurrency.substr(1) + ")"
  else
    return asCurrency
}

export function tomorrow() {
  const tomorrowDate = new Date();
  tomorrowDate.setDate(tomorrowDate.getDate() + 1)
  return tomorrowDate.toLocaleDateString('en-CA', { timeZone: "America/New_York" })
}

export function isTomorrow(dateString) {
  return dateString == tomorrow()
}

export function isToday(dateString) {
  const tomorrowDate = new Date();
  tomorrowDate.setDate(tomorrowDate.getDate())
  return dateString == tomorrowDate.toLocaleDateString('en-CA', { timeZone: "America/New_York" })
}

export function stripZeros(numberString) {
  const numericNumber = Number(numberString)
  return parseFloat(numericNumber.toFixed(4));
}

// match with ApplicationHelper#days_diff
export function daysDiff(dateString) {
  const today = new Date().toLocaleDateString('en-CA', { timeZone: "America/New_York" })
  const days = differenceInCalendarDays(parseISO(today), parseISO(dateString))
  if (days == 0) { return 'today' }
  if (days == 1) { return 'yesterday' }
  if (days == -1) { return 'tomorrow' }
  return `${ days < 0 ? 'in ' : '' }${ Math.abs(days) } days${ days > 0 ? ' ago' : '' }`
}

export function formatDate(dateString) {
  const date = parseISO(dateString);
  const formattedDate = format(date, 'EEE M/d');
  return formattedDate;
}

export function humanizeLabel(string) {
  return (string || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}

export function debounceMs(ms) {
  return document.documentElement.dataset.environment === 'test' ? 50 : ms
}

export function formatDateTime(dateString) {
  const date = parseISO(dateString);
  const formattedDate = format(date, 'p EEE M/d');
  return formattedDate;
}
